<template>
    <div id="ContainerFormsConfiguration">
        <div class="page-height">
            <div class="col-12">
                <h4 v-if="this.$attrs.editMode" class="page-title text-truncate">
                    {{ $t('formsConfiguration.Edit') }}
                </h4>
                <div class="flex-container" v-if="isVisibleProviderLookUp">
                    <div class="row">
                        <div class="col-md-4">
                            <MdSelect
                                :key="formsCofigurationData.providerCode"
                                v-bind:Label="$t('formsConfiguration.eProvider')"
                                v-bind:Options="providerList"
                                v-bind:FieldCode="'code'"
                                v-bind:FieldDescription="'description'"
                                v-bind:Model="providerModel"
                                v-bind:Multiple="false"
                                v-bind:UseParamsAux="true"
                                v
                                v-bind:AuxParam="{ dbField: 'providerCode', uiModel: providerModel }"
                                :Input="handleComboChange"
                            />
                        </div>
                    </div>
                </div>

                <DxTreeList
                    id="treeMenu"
                    :ref="treeListRefKey"
                    :data-source="this.dataSource"
                    :show-borders="true"
                    :column-auto-width="true"
                    :word-wrap-enabled="true"
                    key-expr="itemKey"
                    parent-id-expr="parentId"
                    @saving="SaveOrEdit($event)"
                    @editor-preparing="onEditorPreparingPerm"
                    @cell-prepared="cellPrepared"
                    :height="'72vh'"
                >
                    <DxSearchPanel
                        :visible="true"
                        :width="250"
                        :placeholder="$t('Shared.Search')"
                    />
                    <DxSorting mode="none" />
                    <!-- or "multiple" | "none" -->
                    <DxToolbar>
                        <DxItem name="searchPanel" :width="250" />
                    </DxToolbar>
                    <DxEditing :allow-updating="true" mode="batch" />
                    <DxColumn
                        :width="600"
                        data-field="label"
                        :caption="$t('formsConfiguration.eFields')"
                        :allow-editing="false"
                    />

                    <DxColumn
                        data-field="isRequired"
                        :set-cell-value="setCellValueRequired"
                        headerCellTemplate="headerCellTemplateRequired"
                    />
                    <template #headerCellTemplateRequired="{ data }">
                        <DxCheckBox
                            :value="false"
                            :text="$t('formsConfiguration.eIsRequired')"
                            iconSize="16px"
                            @value-changed="
                                onValueChangedCheck($event, data)
                            "
                        />
                    </template>

                    <DxColumn
                        data-field="isVisible"
                        :set-cell-value="setCellValueVisible" 
                        headerCellTemplate="headerCellTemplateVisieble"
                    />
                    <template #headerCellTemplateVisieble="{ data }">
                        <DxCheckBox
                            :value="false"
                            :text="$t('formsConfiguration.eIsVisible')"
                            iconSize="16px"
                            @value-changed="
                                onValueChangedCheck($event, data)
                            "
                        />
                    </template>
                </DxTreeList>

                <div class="space-actions"></div>
            </div>
            <div class="page-actions">
                <MdButton
                    v-bind:Label="$t('Shared.Back')"
                    v-bind:Name="'btn_forms_configuration_discard_changes'"
                    v-bind:ClassProp="'secondary mx-2 btn-login'"
                    v-on:click="DiscardChanges"
                />
                <MdButton
                    v-bind:Label="$t('Shared.Save')"
                    v-bind:ClassProp="
                        !pendingChanges ? 'primary mx-2' : 'primary btn-login mx-2'
                    "
                    v-on:click="treeList.saveEditData()"
                    v-bind:isReadOnly="!pendingChanges"
                    v-bind:Name="'btn_forms_configuration_save'"
                />
            </div>
        </div>
    </div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import StorageService from '@/services/storage.service.js';
import FieldsSetupService from '@/services/fieldssetup.service.js';
import ProviderService from '@/services/provider.service.js';

import { EventBus } from '../../../../event-bus.js';
import {
    DxTreeList,
    DxColumn,
    DxEditing,
    DxToolbar,
    DxItem,
    DxSearchPanel,
    DxSorting
} from 'devextreme-vue/tree-list';
import { DxCheckBox } from 'devextreme-vue/check-box';
import Permission from '@/common/Permission';

const treeListRefKey = 'myTreeList';
let elemSaveBtn = '';
export default {
    beforeRouteLeave(to, from, next) {
        if (this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$t('Admission.Admission'),
                    okTitle: this.$t('Shared.BtnSave'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(async value => {
                    if (!value) {
                        next();
                    } else {
                        await this.SaveOrEdit();
                        next();
                    }
                });
        } else {
            next();
        }
    },

    name: 'FORMSCONFIGURATION',
    mixins: [ShowMessage, DBFunctions, Permission /*,EventBus*/],
    components: {
        DxTreeList,
        DxColumn,
        DxSearchPanel,
        DxEditing,
        DxToolbar,
        DxItem,
        DxCheckBox,
        DxSorting
    },
    data() {
        return {
            pendingChanges: false,

            formsCofigurationData: {
                recId: 0,
                providerCode: ''
            },

            treeListRefKey,
            dataSource: [],
            providerList: [],
            providerModel: { code: null, description: null },

            isVisibleProviderLookUp: false,

            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                PatientCode: '',
                Mode: this.edit_mode,
                favButtonAtion: false
            }
        };
    },

    computed: {
        treeList: function () {
            const refComponent = this.$refs[treeListRefKey];

            if (!refComponent) {
                return null;
            }

            return refComponent.instance;
        },
    },

    methods: {
        getDataSource() {
            const params = {
                ScreenRecId: this.$route.params.id,
                ProviderCode: this.formsCofigurationData.providerCode,
                SearchCriteria: "",
            };

            FieldsSetupService.getAll(params)
                .then(response => {
                    if (response && response.data) {
                        this.dataSource = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },


        onEditorPreparingPerm(e) {
            if (e.parentType === "dataRow" && e.row) {
                const rowData = e.row.data;

                if (rowData && rowData.isEditable === false) {
                    if (e.dataField === "isRequired" || e.dataField === "isVisible") {
                        e.cancel = true;
                        return;
                    }
                }
            }
        },


        onValueChangedCheck(e, d) {
            let changes = this.treeList.option('editing.changes') || [];
            const dataField = d.column.dataField;

            this.treeList.forEachNode(node => {
                if (node.data && node.data.isEditable === false) {
                    return; 
                }

                let curNode = changes.find(el => el.key === node.key);

                if (curNode) {
                    curNode.data[dataField] = e.value;

                    if (dataField === 'isRequired' && e.value === true) {
                        curNode.data.isVisible = true;
                    }
                    if (dataField === 'isVisible' && e.value === false) {
                        curNode.data.isRequired = false;
                    }
                } else {
                    let newValue = { [dataField]: e.value };

                    if (dataField === 'isRequired' && e.value === true) {
                        newValue.isVisible = true;
                    }
                    if (dataField === 'isVisible' && e.value === false) {
                        newValue.isRequired = false;
                    }

                    changes.push({key: node.key, type: 'update', data:newValue});
                }
            });

            this.treeList.option('editing.changes', changes);
            this.pendingChanges = true;
        },

        cellPrepared(e) {
            if (e.rowType === "data") {
                const rowData = e.data;

                if (rowData && rowData.isEditable === false) {
                    if (e.column.dataField === "isRequired" || e.column.dataField === "isVisible") {
                        if (e.cellElement) {
                            e.cellElement.innerHTML = "";
                        }
                    }
                }
            }
        },

        setCellValueRequired(newData, value) {
            newData.isRequired = value;

            if (value === true) {
                newData.isVisible = true;
            }
            this.pendingChanges = true;
        },

        setCellValueVisible(newData, value, currentRowData) {
            newData.isVisible = value;

            if (value === false) {
                newData.isRequired = false;
            } else {
                newData.isRequired = currentRowData ? (currentRowData.isRequired || false) : false;
            }

            this.pendingChanges = true;

        },

        handleComboChange(selectedOption, params) {
            const codeValue = (selectedOption && selectedOption.code) ? selectedOption.code.trim() : null;
            const descValue = (selectedOption && selectedOption.code) ? selectedOption.description : null;

            if (!params) return;

            if (!codeValue) {
                this.formsCofigurationData[params.dbField] = '';
                this.$set(params.uiModel, 'code', null);
                this.$set(params.uiModel, 'description', null);
                this.dataSource = [];
                return;
            }

            this.formsCofigurationData[params.dbField] = codeValue;
            this.$set(params.uiModel, 'code', codeValue);
            this.$set(params.uiModel, 'description', descValue);

            this.pendingChanges = false; 
            this.getDataSource();
        },

        DiscardChanges() {
            this.checkExistFavorite('/app/formsconfigurationlist');
            this.$router.push({ name: 'formsConfigurationList' });
        },

        getProviders() {
            if (this.$attrs.editMode) {
                const userId = StorageService.getUserId();
        
                ProviderService.getLookUpWOTraining(userId)
                    .then(response => {
                        if (response.status == '200' && response.data) {
                            if (response.data.length === 1) {
                                const unicProvider = response.data[0];
                                this.formsCofigurationData.providerCode = unicProvider.code;
                                this.getDataSource();
                            } else {
                                response.data.forEach(element => {
                                    const templateObject = {
                                        code: element.code ? element.code.trim() : '',
                                        description: element.company || element.company
                                    };

                                    this.providerList.push(templateObject);
                                });

                                this.isVisibleProviderLookUp = true;
                            }
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            }
        },

        SaveOrEdit() {
            const currentProvider = this.formsCofigurationData.providerCode;
            
            if (!currentProvider || currentProvider.trim() === '') {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('formsConfiguration.msgSelectProviderRequired'),
                    'error'
                );
                return false;
            }

            const gridChanges = this.treeList.option('editing.changes') || [];

            if (gridChanges.length === 0) {
                return;
            }

            const payload = {
                ProviderCode: this.formsCofigurationData.providerCode,
                ScreenRecId: this.$route.params.id,
                Changes: gridChanges.map(change => {
                    const nodeData = this.dataSource.find(item => item.recId === change.key);

                    let finalVisible = change.data.isVisible !== undefined ? change.data.isVisible : nodeData?.isVisible;
                    let finalRequired = change.data.isRequired !== undefined ? change.data.isRequired : nodeData?.isRequired;

                    return {
                        FieldsRecId: change.key,
                        IsVisible: finalVisible ? "Y" : "N",
                        IsRequired: finalRequired ? "Y" : "N"
                    };
                })
            };

            FieldsSetupService.saveBulk(payload)
                .then(response => {
                    if (response.status === 200 || response.status === 204) {
                        this.treeList.cancelEditData(); 
                        this.getDataSource();
                        this.pendingChanges = false;

                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        checkUserAction() {
            if (elemSaveBtn.disabled) {
                elemSaveBtn.removeAttribute('disabled');
            }
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        }
    },

    created() {
        this.getProviders();

        EventBus.$on(
            'onChanged',
            function(e) {
                this.pendingChanges = e.Changed;
                this.checkUserAction();
            }.bind(this)
        );
        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },

    mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        setTimeout(
            function() {
                elemSaveBtn = document.getElementById('btn_forms_configuration_save');
                elemSaveBtn.setAttribute('disabled', '');
            },
            50,
            this
        );
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
    }
};
</script>
